import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { StopDefinitionPageRoutingModule } from './stop-definition-routing.module';

import { StopDefinitionPage } from './stop-definition.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, StopDefinitionPageRoutingModule, TranslateModule.forChild()],
  declarations: [StopDefinitionPage]
})
export class StopDefinitionPageModule {}
